import { AppShellContent, Stack, Text, Title } from "@assetwatch/ui";
import { useState } from "react";
import { CategoriesSettingsSection } from "../components/settings/CategoriesSettingsSection";
import { FeaturesSection } from "../components/settings/FeaturesSection";
import { GeneralSettingsSection } from "../components/settings/GeneralSettingsSection";

const SETTINGS_SECTIONS = [
  { id: "general", label: "General" },
  { id: "features", label: "Features" },
  { id: "categories", label: "Categories" },
  { id: "custom-fields", label: "Custom Fields" },
  { id: "user-management", label: "User Management" },
  { id: "integrations", label: "Integrations" },
  { id: "more", label: "More" },
];

export function SettingsScreen() {
  const [activeSection, setActiveSection] = useState("general");

  return (
    <AppShellContent>
      <Stack gap={24}>
        <Title size="lg">Settings</Title>

        <div className="flex flex-col gap-(--spacing-32) md:flex-row md:items-start">
          {/* @ds-deviation: the POC settings list is a vertical section nav with a left accent bar. The DS Tabs are horizontal underline tabs and primitives must not be edited in product work. Proposed resolution: promote a vertical tabs variant into the design system. */}
          <nav
            aria-label="Settings sections"
            className="flex flex-col gap-(--spacing-4) md:w-50 md:shrink-0"
          >
            {SETTINGS_SECTIONS.map((section) => {
              const isActive = section.id === activeSection;
              return (
                <button
                  key={section.id}
                  type="button"
                  aria-current={isActive ? "page" : undefined}
                  onClick={() => setActiveSection(section.id)}
                  className={`relative flex w-full items-center rounded-(--radius-sm) px-(--spacing-12) py-(--spacing-8) text-left hover:bg-surface-hover ${
                    isActive
                      ? "font-bold text-text-default"
                      : "font-medium text-text-subtle"
                  }`}
                >
                  {isActive && (
                    <span className="absolute top-(--spacing-8) bottom-(--spacing-8) left-0 w-0.5 rounded-r-full bg-primary" />
                  )}
                  <span className="text-(length:--font-size-body-medium)">
                    {section.label}
                  </span>
                </button>
              );
            })}
          </nav>

          <div className="min-w-0 flex-1">
            {activeSection === "general" ? (
              <GeneralSettingsSection />
            ) : activeSection === "features" ? (
              <FeaturesSection />
            ) : activeSection === "categories" ? (
              <CategoriesSettingsSection />
            ) : (
              <Text tone="subtle">
                {SETTINGS_SECTIONS.find((s) => s.id === activeSection)?.label}{" "}
                content will go here
              </Text>
            )}
          </div>
        </div>
      </Stack>
    </AppShellContent>
  );
}
